import { render, staticRenderFns } from "./blackListAddDialog.vue?vue&type=template&id=2a5eb6d4&scoped=true"
import script from "./blackListAddDialog.vue?vue&type=script&lang=js"
export * from "./blackListAddDialog.vue?vue&type=script&lang=js"
import style0 from "./blackListAddDialog.vue?vue&type=style&index=0&id=2a5eb6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5eb6d4",
  null
  
)

export default component.exports